import './components/LineChart';
import './components/DoughnutChart';
import './components/CircleProgress';
import './components/Ratings';
import './components/EmotionChart';
import './components/CustomerJourney';
import componentManager from 'nms-dashboard-js';
import IExtension from "../../IExtension";
import {Naja, SuccessEvent} from "naja";


export default class DashboardExtension implements IExtension {
    private naja: Naja;

    public initialize(naja: Naja): void {
        this.naja = naja;

        componentManager.setAttributeNamespace('db');
        componentManager.setSendInitialRequest(false);
        componentManager.run(document.body);

        naja.addEventListener('success', (e: SuccessEvent) => {
            const payload = e.detail.payload as { componentsData?: unknown };
            if (payload?.componentsData) {
                componentManager.delegateDataToComponents(payload);
            }
        });
    }
}
